export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9649.6aae4fa8.jpg";